// extracted by mini-css-extract-plugin
export var quantityInput = "_o3-0";